import React from 'react';

// There are no stats for 'free-response' questions.
export const FreeResponseResponseStats = () => {
  return <div />;
};
